const BACKGROUND_IMAGE =
  "https://vws-front-store.s3.ap-northeast-2.amazonaws.com/company/merit-background.webp";

export function CompanyMerit() {
  return (
    <section
      className="px-4 py-[120px] bg-cover bg-center"
      style={{
        backgroundImage: `url(${BACKGROUND_IMAGE})`,
      }}
    >
      <div className="max-w-[1150px] mx-auto text-center">
        <h2 className="text-heading-1-mb desktop:text-heading-1 text-[#212121]">
          2026년 2월 기준
        </h2>
        <div className="mt-4">
          <p className="text-heading-2-mb desktop:text-heading-2 text-[#212121]">
            저희 법률사무소는 대한민국에서 가장 합리적인 비용으로 소송을 진행할
            수 있는 곳입니다.
          </p>
          <p className="text-body-2-mb desktop:text-body-2 !font-normal text-[#4F4F4F]">
            (※ 공익적 목적의 한시적 캠페인으로, 특정 사건 수에 한해 적용됩니다.)
          </p>
        </div>
        {/* 세로 막대기 */}
        <div className="w-[3px] h-[31px] bg-c-primary mx-auto mt-6" />
        <div className="mt-[72px] desktop:mt-[99px] text-body-1-mb desktop:text-body-1 text-[#4F4F4F]">
          <p className="">
            채권 생태계의 사각지대에 놓인 모든 분들께 소중한 재산과 신용을
            되찾아드리고자 하며
          </p>
          <p>더 나아가 건강한 신용 사회를 함께 만들어 가고자 합니다.</p>
        </div>
      </div>
    </section>
  );
}
